const posthogEvents = {
    CAMPAIGN_CREATE_STARTED: 'Campaign.Create.Started',
    CAMPAIGN_CREATE_SUBMITTED: 'Campaign.Create.Submitted',
    CAMPAIGN_CREATE_SUCCESS: 'Campaign.Create.Success',
    CAMPAIGN_CREATE_FAILED: 'Campaign.Create.Failed',
    CAMPAIGN_CREATE_TYPE_SUBMITTED: 'Campaign.Create.Type.Submitted',
    CAMPAIGN_CREATE_TYPE_COMPARISON_SELECTED: 'Campaign.Create.Type.Comparison.Selected',
    CAMPAIGN_CREATE_ADDONS_SELECTED: 'Campaign.Create.Addons.Selected',
    CAMPAIGN_CREATE_ADDONS_SUBMITTED: 'Campaign.Create.Addons.Submitted',
    CAMPAIGN_CREATE_FORM_STARTED: 'Campaign.Create.Form.Started',
    CAMPAIGN_CREATE_FORM_SUBMITTED: 'Campaign.Create.Form.Submitted',
    CAMPAIGN_CREATE_FORM_SUCCESS: 'Campaign.Create.Form.Success',
    CAMPAIGN_CREATE_FORM_FAILED: 'Campaign.Create.Form.Failed',
    CAMPAIGN_CREATE_PAGE_STARTED: 'Campaign.Create.Page.Started',
    CAMPAIGN_CREATE_PAGE_SUBMITTED: 'Campaign.Create.Page.Submitted',
    CAMPAIGN_CREATE_PAGE_SUCCESS: 'Campaign.Create.Page.Success',
    CAMPAIGN_CREATE_PAGE_FAILED: 'Campaign.Create.Page.Failed',
    CAMPAIGN_CREATE_EVENT_STARTED: 'Campaign.Create.Event.Started',
    CAMPAIGN_CREATE_EVENT_SUBMITTED: 'Campaign.Create.Event.Submitted',
    CAMPAIGN_CREATE_EVENT_SUCCESS: 'Campaign.Create.Event.Success',
    CAMPAIGN_CREATE_EVENT_FAILED: 'Campaign.Create.Event.Failed',
    ACCOUNT_VERIFY_NONPROFIT_STARTED: 'Account.Verify.NonProfit.Started',
    ACCOUNT_VERIFY_NONPROFIT_SUBMITTED: 'Account.Verify.NonProfit.Submitted',
    ACCOUNT_VERIFY_NONPROFIT_SUCCESS: 'Account.Verify.NonProfit.Success',
    ACCOUNT_VERIFY_NONPROFIT_FAILED: 'Account.Verify.NonProfit.Failed',
    USER_CREATE_STARTED: 'User.Create.Started',
    USER_CREATE_SUBMITTED: 'User.Create.Submitted',
    USER_CREATE_SUCCESS: 'User.Create.Success',
    USER_CREATE_FAILED: 'User.Create.Failed',
    AUCTION_CREATE_STARTED: 'Campaign.Create.Auction.Started',
    AUCTION_CREATE_SUBMITTED: 'Campaign.Create.Auction.Submitted',
    AUCTION_CREATE_SUCCESS: 'Campaign.Create.Auction.Success',
    AUCTION_CREATE_FAILED: 'Campaign.Create.Auction.Failed',
    PAYOUT_PAID_STARTED: 'Payout.Paid.Started',
    PAYOUT_PAID_SUBMITTED: 'Payout.Paid.Submitted',
    PAYOUT_PAID_FAILED: 'Payout.Paid.Failed',
    MERCHANT_ACCOUNT_SETUP_STARTED: 'MerchantAccount.Setup.Started',
    DASHBOARD_VIEWED: 'Dashboard.Viewed',
    DASHBOARD_CHECKLIST_ITEM_SELECTED: 'Dashboard.ChecklistItem.Selected',
    DASHBOARD_RECOMMENDED_ACTION_SELECTED: 'Dashboard.RecommendedAction.Selected',
    DASHBOARD_PROFILE_ITEM_SELECTED: 'Dashboard.ProfileItem.Selected',
    DASHBOARD_RAISED_ON_SUCCESS_DIALOG_VIEWED: 'Dashboard.RaisedOneSuccessDialog.Viewed',
    DASHBOARD_RAISED_ON_SUCCESS_DIALOG_DISMISSED: 'Dashboard.RaisedOneSuccessDialog.Dismissed',
    DASHBOARD_RECOMMENDED_ACTION_PLUS_TRIAL_STARTED:
        'Dashboard.RecommendedAction.PlusTrial.Started',
    FLOATING_CHECKLIST_VIEWED: 'FloatingChecklist.Viewed',
    FLOATING_CHECKLIST_CHECKLIST_ITEM_SELECTED: 'FloatingChecklist.ChecklistItem.Selected',
    FLOATING_CHECKLIST_DISMISSED: 'FloatingChecklist.Dismissed',
    FLOATING_CHECKLIST_LONGTERM_DIALOG_DISMISSED: 'FloatingChecklist.LongtermDialog.Dismissed',
    DASHBOARD_OVERAGES_CONTACTS_BANNER_SELECTED: 'Dashboard.Overages.Contacts.Banner.Selected',
    DASHBOARD_OVERAGES_CONTACTS_BANNER_DISMISSED: 'Dashboard.Overages.Contacts.Banner.Dismissed',
    DASHBOARD_OVERAGES_IMPORTS_BANNER_SELECTED: 'Dashboard.Overages.Imports.Banner.Selected',
    CONNECT_PAYOUT_METHOD_BANNER_SELECTED: 'ConnectPayoutMethod.Banner.Selected',
    CONNECT_PAYOUT_METHOD_BANNER_DISMISSED: 'ConnectPayoutMethod.Banner.Dismissed',
    DASHBOARD_OVERAGES_BILLING_BANNER_SELECTED: 'Dashboard.Overages.Billing.Banner.Selected',
    DASHBOARD_OVERAGES_BILLING_BANNER_SUBMITTED: 'Dashboard.Overages.Billing.Banner.Submitted',
    DASHBOARD_OVERAGES_BILLING_BANNER_DISMISSED: 'Dashboard.Overages.Billing.Banner.Dismissed',
    DASHBOARD_OVERAGES_BILLING_BANNER_CANCELLED: 'Dashboard.Overages.Billing.Banner.Cancelled',
    DASHBOARD_BILLING_BILLING_CYCLE_SELECTED: 'Dashboard.Billing.BillingCycle.Selected',
    DASHBOARD_BILLING_PLAN_SELECTED: 'Dashboard.Billing.Plan.Selected',
    DASHBOARD_BILLING_PLAN_UPDATE_SELECTED: 'Dashboard.Billing.Plan.Update.Selected',
    DASHBOARD_BILLING_PLAN_UPDATE_SUBMITTED: 'Dashboard.Billing.Plan.Update.Submitted',
    DASHBOARD_BILLING_PLAN_UPDATE_CANCELLED: 'Dashboard.Billing.Plan.Update.Cancelled',
};

type PostHogEvent = (typeof posthogEvents)[keyof typeof posthogEvents];

export { posthogEvents };
export type { PostHogEvent };
